export enum NormalStatus {
  Activated = 'Activated',
  Deactivated = 'Deactivated',
}

export const normalStatusOptions = [{
  value: NormalStatus.Activated,
  label: NormalStatus.Activated.toString(),
}, {
  value: NormalStatus.Deactivated,
  label: NormalStatus.Deactivated.toString(),
}]